import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ComponentBaseComponent } from '../../../core/components/component-base/component-base.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FileService } from '../../../core/services/file.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '../../../modal/state-modal/state-modal.component';

@Component({
  selector: 'tt-edi-import-file-upload',
  templateUrl: './edi-import-file-upload.component.html',
  styleUrls: ['./edi-import-file-upload.component.css']
})
export class EdiImportFileUploadComponent extends ComponentBaseComponent implements OnInit {

    public files: File[] = [];

    private translations: { [key: string]: string } = {
        edi_import_file_upload_heading: '',
    };

    public uploading = false;

    constructor(
        private state: StateService,
        private datatask: DataTaskService,
        private modal: ModalService,
        private file: FileService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        super();
    }

    // Read the file as raw bytes and Base64URL-encode them without changing the original file encoding
    private async fileToBase64Url(file: File): Promise<string> {
        const buffer = await file.arrayBuffer();
        const bytes = new Uint8Array(buffer);

        let binary = '';

        for (let i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }

        return btoa(binary)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    public async uploadFiles() {
        this.uploading = true;

        const progress = this.modal.openProgressDialog({ value: 0, max: this.files.length });
        let count = 0;

        try {
            const promises = this.files.map(async (file) => {
                let filename = file.name;
                let filecontent: string = await this.fileToBase64Url(file);

                const response = (await this.datatask.Post(4029, {
                    filename: this.base64UrlEncodeUnicode(filename),
                    filecontent: filecontent
                }))[0];

                count++;
                progress.updateValue(count);

                return response;
            });

            const responses = await Promise.all(promises);

            const errors = responses.filter((response) => response.errorcode !== '0');

            if (errors.length > 0) {
                progress.updateStatus('invalid');
                progress.updateInvalidText(errors.reduce((message, error) => message + '\n' + error.errormessage, ''));
            } else {
                progress.updateStatus('finish');
                this.files = [];
            }
        } catch (error) {
            let errormessage = !!error && error instanceof Object ? JSON.stringify(error, null, 2) : `${error}`;
            progress.updateStatus('invalid');
            progress.updateInvalidText(errormessage);
        } finally {
            this.uploading = false;
        }
    }

    private async init() {
    }

    ngOnInit(): void {
        this.navigator?.setSize?.({ width: 'min(95vw, 40rem' });
        this.navigator?.setHeading?.('edi_import_file_upload_heading', true);
        this.init();
    }
}
